<template>
  <div>
    <div class="breadcrumbs mb-2">
      <v-breadcrumbs divider=">" :items="breadcrumbsList">
        <template v-slot:item="{ item }">
          <v-breadcrumbs-item
            :to="{ name: item.path }"
            :disabled="item.disabled"
            exact
          >
            {{ item.text }}
          </v-breadcrumbs-item>
        </template>
      </v-breadcrumbs>
    </div>
    <PageTitle pageHeading="Support Email Addresses" :rightsideButton="true">
      <v-btn
        dark
        class="font-weight-bold px-2"
        link
        :to="{ name: 'new-support-email' }"
      >
        <span class="pl-2 pr-3"> Add support email </span>
      </v-btn>
    </PageTitle>

    <v-data-table
      :headers="headers"
      :items="emailList"
      :items-per-page="10"
      :options.sync="pagination"
      :server-items-length="totalItems"
      class="elevation-1 mt-8 emails-list-table"
      :footer-props="{
        'items-per-page-options': [10, 25, 50, 75, 100],
      }"
      :loading="loading"
    >
      <template v-slot:[`item.name`]="{ item }">
        <!-- <router-link
          class="body-1 word-break text-ellipsis cursor-pointer text-capitalize"
        > -->
        <span v-if="item.name"> {{ item.name | upperCaseFirst }}</span>
        <span v-else> -- </span>
        <!-- </router-link -->
      </template>

      <template v-slot:[`item.verified_at`]="{ item }">
        <v-chip v-if="item.verified_at !== null" color="success" small outlined>
          Verified</v-chip
        >
        <v-chip v-else color="#03B6FC" small outlined> Pending</v-chip>
      </template>

      <template v-slot:[`item.email`]="{ item }">
        <span> {{ item.email }}</span>
      </template>

      <template v-slot:[`item.action`]="{ item }">
        <span @click.stop class="body-1">
          <v-menu left bottom offset-y>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" icon>
                <v-icon class="font-weight-bold">mdi-dots-vertical</v-icon>
              </v-btn>
            </template>

            <v-list dense class="pa-0">
              <v-list-item-group>
                <v-list-item
                  v-if="!item.verified_at"
                  id="edit-email-link"
                  @click="showVerifyDialog(item)"
                >
                  <v-list-item-icon class="mr-1">
                    <v-icon size="20"> mdi-email </v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title class="body-1 font-weight-regular"
                      >Verify {{ item.verified_at }}</v-list-item-title
                    >
                  </v-list-item-content>
                </v-list-item>

                <v-list-item
                  id="edit-email-link"
                  link
                  :to="{ name: 'edit-email', params: { id: item.id } }"
                >
                  <v-list-item-icon class="mr-1">
                    <v-icon size="20"> mdi-pencil </v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title class="body-1 font-weight-regular"
                      >Edit</v-list-item-title
                    >
                  </v-list-item-content>
                </v-list-item>
                <v-list-item
                  id="delete-service-hours-link"
                  @click="
                    getRowData(item);
                    deleteDialog = true;
                  "
                >
                  <v-list-item-icon class="mr-1">
                    <v-icon size="20">delete</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title class="body-1 font-weight-regular"
                      >Delete</v-list-item-title
                    >
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-menu>
        </span>
      </template>
    </v-data-table>

    <!-- delete support emails --->
    <v-dialog v-model="deleteDialog" max-width="520">
      <v-card class="pa-2 py-3">
        <v-card-title class="text-h6 font-weight-medium-custom">
          <span class="secondary--font"> Delete Support Email Address </span>
        </v-card-title>
        <v-card-text class="body-2">
          Are you sure you want to delete this support email address ?
          <div class="mt-5">
            <b class="black--text">
              Warning: This action is irreversible and you will no longer be
              able to send or receive emails using this email address. Please
              confirm that you want to proceed with this deletion.
            </b>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="deleteDialog = false" class="font-weight-bold">
            Cancel
          </v-btn>
          <v-btn dark @click="deleteEmail()" class="font-weight-bold">
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!------>

    <!-- email verification modal -->

    <v-dialog v-model="emailVerification" width="800">
      <v-card class="pa-3 email-verify">
        <v-card-title class="text-h6 mb-3">
          <span class="secondary--font font-weight-medium-custom">
            Email Verification
          </span>
        </v-card-title>
        <v-card-text>
          <div :class="$vuetify.breakpoint.smAndDown ? '' : 'd-flex'">
            <v-text-field
              outlined
              disabled
              v-model="forwardEmail"
              class="align-self-center forward-email"
              hide-details
              background-color="#FAFAFA"
            >
            </v-text-field>
            <v-btn
              class="align-self-center ml-2 body-2 font-weight-bold copy-btn"
              outlined
              v-clipboard:copy="forwardEmail"
              v-clipboard:success="onCopy"
            >
              <span class="secondary--font font-weight-bold">Copy </span>
            </v-btn>
          </div>

          <div>
            <p class="mt-5 body-2">
              Copy forwarding address above and sign in to your mailbox
              <b> Settings -> Forwarding and POP/IMAP. </b> <br />
              Add the copied email as a forwarding address. Doing this you are
              able to see customer emails in the tickets tab.
            </p>
          </div>
          <v-btn
            v-if="!verifiedText"
            class="mt-5"
            color="black"
            @click="verifyEmail()"
            :loading="verifyLoader"
          >
            <span class="white--text font-weight-bold"> verify </span>
          </v-btn>

          <div v-else class="d-flex mt-3">
            <v-list-item-icon
              class="mr-1 body-1 ml-0"
              :class="verifiedStatus ? 'success-color' : 'error-color'"
            >
              <v-icon size="20" :color="verifiedStatus ? 'success' : 'error'"
                >mdi-checkbox-marked-circle</v-icon
              >
              <span class="secondary--font pl-2"> {{ verifiedText }} </span>
            </v-list-item-icon>
            <v-btn
              v-if="!verifiedStatus"
              outlined
              @click="verifyEmail()"
              class="body-2 font-weight-bold mt-2 ml-2"
            >
              <span class="secondary--font"> Retry </span>
            </v-btn>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green-darken-1" text @click="emailVerification = false">
            <span class="secondary--font font-weight-bold">close </span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import PageTitle from "@/components/shared/PageTitle.vue";
import { $mailbox } from "@/services/Index";
import { copyText } from "@/mixins/copyText";

export default {
  name: "service-hours-index",
  mixins: [copyText],
  components: {
    PageTitle,
  },
  data: () => {
    return {
      breadcrumbsList: [
        {
          text: "Settings",
          disabled: false,
          path: "settings",
        },
        {
          text: "Emails",
          disabled: true,
          path: "",
        },
      ],

      emailList: [],
      headers: [
        {
          text: "Name",
          align: "start",
          value: "name",
        },
        { text: "Support Email Address", value: "email" },
        { text: "Status", value: "verified_at" },

        {
          text: "Actions",
          value: "action",
          align: "right",
          sortable: false,
        },
      ],
      totalItems: 0,
      pagination: {},
      loading: false,
      deleteDialog: false,
      selectedData: null,
      globalSearchKeyword: "",
      emailVerification: false,
      forwardEmail: "",
      verifyLoader: false,
      verifiedText: "",
      verifiedStatus: false,
    };
  },
  watch: {
    pagination: {
      handler(newVal, oldVal) {
        /** prevent this check to invoked function on page load */
        if (oldVal.itemsPerPage) {
          this.getSupportEmails();
        }
      },
      deep: true,
    },

    /*** temporary code for global search */
    $route: {
      handler: function (to, from) {
        this.globalSearchKeyword = "";
        let name = to.query.name;
        if (name) {
          this.globalSearchKeyword = name;
          this.getSupportEmails();
        } else {
          this.getSupportEmails();
        }
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    this.getSupportEmails();
  },

  methods: {
    /** getSupportEmails data from API's */
    async getSupportEmails() {
      this.loading = true;
      const { page, itemsPerPage, sortBy, sortDesc } = this.pagination;
      const data = {
        page,
        per_page: itemsPerPage,
        q: {
          name_cont: this.globalSearchKeyword,
          email_cont: this.globalSearchKeyword,
          id_in: this.globalSearchKeyword,
          m: "or",
        },
      };
      // If sorting ..
      if (sortBy && sortBy.length) {
        const dir = sortDesc.length
          ? sortDesc[0] === true
            ? "desc"
            : "asc"
          : "";
        data.q.s = `${sortBy[0]} ${dir}`;
      }
      try {
        const response = await $mailbox.fetchList(data, {});
        if (response.data) {
          this.totalItems = response.data.pagination.total_count;
          this.emailList = response.data.mailboxes;
          this.loading = false;
        }
      } catch (error) {
        this.loading = false;
      }
    },

    getRowData(item) {
      this.selectedData = item;
    },

    /** delete email  method */
    async deleteEmail() {
      let payload = {
        id: this.selectedData.id,
      };
      try {
        const response = await $mailbox.delete(payload.id, {});
        if (response.data) {
          this.deleteDialog = false;
          this.getSupportEmails();
          this.$store.dispatch("ui/snackbar", [
            {
              title: "Delete Support Email Address",
              message: `Selected support email has been deleted.`,
              type: "success",
            },
          ]);
        }
      } catch (error) {
        this.deleteDialog = false;
      }
    },

    async verifyEmail() {
      this.verifiedText = "";
      let payload = {
        id: this.selectedData.id,
      };
      this.verifyLoader = true;
      try {
        const response = await $mailbox.verify(payload.id, {});
        if (response.data) {
          let time = 5000;
          for (let i = 0; i < 10; i++) {
            setTimeout(() => {
              if (!this.verifiedStatus) {
                this.getSingleEmailData(payload.id, i);
              }
            }, time);
            time = time + 2000;
          }
        }
      } catch (error) {
        console.log("error==", error);
        this.deleteDialog = false;
      }
    },

    /* eslint-disable */
    async getSingleEmailData(id, index) {
      try {
        const response = await $mailbox.getSingle(id, {});
        if (response.data) {
          if (response.data.verified_at) {
            this.verifyLoader = false;
            this.verifiedText = "Verified Successfully";
            this.verifiedStatus = true;
            this.getSupportEmails();
          } else {
            if (index == 9) {
              this.verifiedText = "Verification Failed!";
              this.verifyLoader = false;
              this.verifiedStatus = false;
              this.getSupportEmails();
            }
          }
        }
      } catch (error) {}
    },

    showVerifyDialog(item) {
      this.verifiedText = "";
      this.getRowData(item);
      this.emailVerification = true;
      this.forwardEmail = item.forward_email;
    },
  },
};
</script>

<style lang="scss">
.email-verify {
  .v-btn__loader {
    color: grey !important;
  }
  .v-input input,
  .v-chip .v-chip__content {
    text-transform: lowercase !important;
  }
}
</style>
